let option: IOption | null = null;

// option 가공
const setOption = (options: IOption) => {
  if (!options || typeof options !== 'object') {
    return null;
  }

  const { serviceAlias, apiDomain, productId } = options;

  return serviceAlias && apiDomain && productId ? options : null;
};

export const useOption = (options?: IOption) => {
  if (options) {
    option = setOption(options);
  }

  return option;
};
